import { render } from "./index.vue?vue&type=template&id=07366f6a&ts=true"
import script from "./index.vue?vue&type=script&lang=ts"
export * from "./index.vue?vue&type=script&lang=ts"

import exportComponent from "/home/jenkins/agent/workspace/miyo-prod/ftrc-prd/src/project/fotile-riskctl/code/frontend/mgr/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__